export enum SocialNetworks {
    None = 0,
    Facebook = 1 << 0,
    Twitter = 1 << 1,
    Linkedin = 1 << 2,
    Mail = 1 << 3
}
